export default __webpack_public_path__ + "static/media/5.671a31fc.png";